import { device } from '@src/common/breakpoints';
import { colors, LayoutColors } from '@src/core/theme';
import {
  BodyExtraSmall,
  BodyExtraSmallMedium,
  BodyLargeBold,
  BodyRegularMedium,
  BodyRegularSemiBold,
  BodySmall,
  BodySmallMedium,
} from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const ResourceContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TariffContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TariffList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const CartItemTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const CartItemTotalLabel = styled.p`
  ${BodyExtraSmallMedium}
  ${device.mobile} {
    ${BodySmallMedium}
  }
`;

export const CartItemTotalValue = styled.p`
  ${BodySmallMedium}
  ${device.mobile} {
    ${BodyRegularSemiBold}
  }
`;
export const AdditionalsProductValue = styled.p`
  ${BodyExtraSmall}
  ${device.mobile} {
    ${BodySmall}
  }
`;
export const AdditionalsProductName = styled.p`
  ${BodySmallMedium}
  && {
    margin-bottom: 8px;
  }
  ${device.mobile} {
    ${BodyRegularMedium}
  }
`;

export const AdditionalsContainer = styled.div`
  border: 1px solid ${colors.black[400]};
  border-radius: 4px;
  margin-top: 8px;
  padding: 8px;
`;

export const InformationLabel = styled.p`
  ${BodyExtraSmall}
  ${device.mobile} {
    ${BodySmall}
  }
`;

export const AdditionalsTitle = styled.p`
  ${BodySmall}
  ${device.mobile} {
    ${BodyRegularSemiBold}
  }
`;

export const InformationValue = styled.p`
  ${BodyExtraSmallMedium}
  ${device.mobile} {
    ${BodySmall}
  }

  text-align: right;
`;

export const ProductName = styled.p`
  ${BodyRegularSemiBold}
  ${device.mobile} {
    ${BodyLargeBold}
  }
`;

export const ProductImage = styled.div`
  border-radius: 8px;
  width: 100px;
  height: 100px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${device.mobile} {
    width: 113px;
    height: 113px;
  }
`;

export const ProductInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
`;

export const ProductInformation = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem;
`;

export const CartProduct = styled.div`
  display: flex;
  gap: 7px;
`;

export const CartAdditionals = styled.div`
  margin-top: 1rem;
`;

export const Container = styled.div`
  background-color: ${LayoutColors.whiteDark};
  padding: 0.5rem;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  ${device.smallTablet} {
    gap: 1rem;
    padding: 1rem;
  }
`;

export const PackagePriceContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;

  &:last-child {
    margin-top: 0.375rem;
  }
`;

export const PriceItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.25rem;

  p,
  span {
    ${BodySmallMedium};
    color: ${LayoutColors.blackMain};
    margin: 0px;
  }

  strong {
    ${BodyRegularSemiBold};
    color: ${LayoutColors.blackMain};
    margin: 0px;
  }
`;

export const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.black[200]};

  & > div {
    border-bottom: 1px solid ${LayoutColors.blackLight};
    background: transparent !important;
    padding: 0.5rem;

    p[data-product-name] {
      ${BodyRegularSemiBold};
    }

    div[data-product-info] {
      gap: 0.25rem;
    }
  }

  & > div:last-child {
    border-bottom: none;
  }
`;

export const AccordionWrapper = styled.div`
  & > .MuiPaper-root {
    margin-bottom: 0px;
    background-color: ${colors.black[200]} !important;
  }
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-bottom: 4px;
`;

export const ProductProviderName = styled.p`
  ${BodyExtraSmall};
  color: ${LayoutColors.blackMain};
  margin-top: -2px;
`;
